<template>
    <v-layout>
        <v-flex xs12>
            <v-card xs12>
                <v-toolbar>
                    <v-btn disabled icon>
                        <v-icon>settings</v-icon>
                    </v-btn>
                    <v-toolbar-title>Settings</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                        <v-icon>help</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm6 md3>
                            <SettingsUser />
                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>>

<script>
    export default {
        name: "Settings",
        components: {
            SettingsUser: () => import("../components/SettingsUser")
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>

</style>
